import * as React from 'react';
import { memo } from 'react';

const AverageBookingValue = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M6.33594 15.833V30.833C6.33594 31.6095 6.33594 31.9978 6.4628 32.3042C6.63195 32.7125 6.95642 33.037 7.3648 33.2062C7.67109 33.333 8.05937 33.333 8.83594 33.333C9.6125 33.333 10.0008 33.333 10.3071 33.2062C10.7155 33.037 11.0399 32.7125 11.2091 32.3042C11.3359 31.9978 11.3359 31.6095 11.3359 30.833V15.833C11.3359 15.0564 11.3359 14.6682 11.2091 14.3619C11.0399 13.9535 10.7155 13.629 10.3071 13.4599C10.0008 13.333 9.6125 13.333 8.83594 13.333C8.05937 13.333 7.67109 13.333 7.3648 13.4599C6.95642 13.629 6.63195 13.9535 6.4628 14.3619C6.33594 14.6682 6.33594 15.0564 6.33594 15.833Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M18 9.16699V30.8328C18 31.6093 18 31.9977 18.1268 32.304C18.296 32.7123 18.6205 33.0368 19.0288 33.206C19.3352 33.3328 19.7235 33.3328 20.5 33.3328C21.2765 33.3328 21.6648 33.3328 21.9712 33.206C22.3795 33.0368 22.704 32.7123 22.8732 32.304C23 31.9977 23 31.6093 23 30.8328V9.16699C23 8.39043 23 8.00214 22.8732 7.69586C22.704 7.28748 22.3795 6.96301 21.9712 6.79386C21.6648 6.66699 21.2765 6.66699 20.5 6.66699C19.7235 6.66699 19.3352 6.66699 19.0288 6.79386C18.6205 6.96301 18.296 7.28748 18.1268 7.69586C18 8.00214 18 8.39043 18 9.16699Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M29.6641 20.833V30.833C29.6641 31.6095 29.6641 31.9978 29.7909 32.3042C29.9601 32.7125 30.2846 33.037 30.6929 33.2062C30.9992 33.333 31.3876 33.333 32.1641 33.333C32.9406 33.333 33.3289 33.333 33.6352 33.2062C34.0436 33.037 34.3681 32.7125 34.5372 32.3042C34.6641 31.9978 34.6641 31.6095 34.6641 30.833V20.833C34.6641 20.0565 34.6641 19.6682 34.5372 19.3618C34.3681 18.9535 34.0436 18.629 33.6352 18.4598C33.3289 18.333 32.9406 18.333 32.1641 18.333C31.3876 18.333 30.9992 18.333 30.6929 18.4598C30.2846 18.629 29.9601 18.9535 29.7909 19.3618C29.6641 19.6682 29.6641 20.0565 29.6641 20.833Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

const Memo = memo(AverageBookingValue);
export default Memo;
